/** Index of the last character of the comment at `at`, or `at` if there is none. */
export function endOfComment(source: string, at: number): number {
  if (source[at] !== "/") return at;
  if (source[at + 1] === "/") {
    // line - 1: the newline ends the comment, it is not part of it.
    const line = source.indexOf("\n", at);
    return line === -1 ? source.length : line - 1;
  }
  if (source[at + 1] === "*") {
    const block = source.indexOf("*/", at + 2);
    return block === -1 ? source.length : block + 1;
  }
  return at;
}
